var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Theme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13v50h62V13H7zm7.84 46l15.52-19.64L45.6 59H14.84zm36.53 0l-5-6.42 6-6.72L63.15 59H51.37zM65 54.7L52.6 39.49l-8.79 9.76L30.39 32 11 56.51V17h54v37.7zM42 29a4 4 0 014-4h.11a5 5 0 019.8 0H56a4 4 0 110 8H46a4 4 0 01-4-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Theme.93811bd3.svg";
export { SvgJ2Theme as ReactComponent };